import routes from '#webui/router/routes';
import type { MenuDataType } from '@c4-links/vue3-links-components';
import type { RouteLocationMatched } from 'vue-router';
import type { useLanguage } from '../composables/useLanguage';

type SideBarMenuDataParams = {
  t: ReturnType<typeof useLanguage>['t'];
  matches: RouteLocationMatched[];
};

export const sideBarMenuData = ({ t, matches }: SideBarMenuDataParams): MenuDataType[] => {
  const isCurrentPath = (path: string) => matches.some((match) => match.path.includes(path));

  return [
    {
      id: 'innovation',
      icon: 'trending-up',
      isNewTab: false,
      selected: isCurrentPath(routes.innovation.path),
      name: t(routes.innovation.name),
      path: routes.innovation.path,
      childSection: null
    },
    {
      id: 'utilities-section',
      path: null,
      selected: false,
      icon: null,
      name: t('inno_navbar.utilities'),
      childSection: [
        {
          name: t(routes.contact.name),
          id: 'contact',
          icon: 'help-circle',
          path: routes.contact.path,
          childSection: null
        }
      ]
    }
  ];
};
